import _ from "lodash";
import { v4 as uuidV4 } from "uuid";

import { ACCEPT_UPLOAD_LIST } from "@static/ACCEPT_UPLOAD_LIST";
import { IS_IMAGE } from "@static/MEDIA_TYPE";

const DEFAULT_IMAGE_DURATION = 15;

const getVideoDuration = ({ file, setValue }) => {
  const url = URL.createObjectURL(file);
  const video = document.createElement("video");
  video.src = url;
  video.onloadedmetadata = () => {
    setValue("duration", Math.round(video.duration));
    URL.revokeObjectURL(url);
  };
};

export const generateDragProps = ({ setFileUpload, setValue }) => {
  return {
    name: "file",
    multiple: false,
    accept: ACCEPT_UPLOAD_LIST,
    beforeUpload: (file) => {
      console.log("file :>> ", file);

      setFileUpload(file);
      const fileName = _.get(file, ["name"]);
      const fileType = _.get(file, ["type"]);
      const fileSize = _.get(file, ["size"]);
      const fileKey = uuidV4();
      const extension = _.chain(fileName).split(".").last().value();
      const isImage = _.chain(IS_IMAGE).includes(extension).value();
      setValue("display_name", fileName);
      setValue("extension", extension);
      setValue("fileType", fileType);
      setValue("fileSize", fileSize);
      setValue("fileKey", fileKey);

      //

      //

      if (isImage) {
        setValue("duration", DEFAULT_IMAGE_DURATION);
      } else {
        getVideoDuration({ file, setValue });
      }

      return false;
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
  };
};
